/* eslint-disable import/prefer-default-export */
export enum Role {
    Administrator = 'ADMINISTRATOR',
    PointsAdministrator = 'POINTS_ADMINISTRATOR',
    Integrator = 'INTEGRATOR',
    Commercial = 'COMMERCIAL',
    CommercialSupervisor = 'COMMERCIAL_SUPERVISOR',
    Financial = 'FINANCIAL',
    TechnicalSupport = 'TECHNICAL_SUPPORT',
    Logistics = 'LOGISTICS',
    CustomerSuccess = 'CUSTOMER_SUCCESS',
}
